export const MESSAGE_TYPE = {
  UserMessage: 0,
  NewOTCOffer: 5,
  BustOutPrisoner: 6,
  BuyOutPrisoner: 7,
  FamilyInvitation: 8,
  AdminMessage: 9,
};

export const MESSAGE_SUBJECT_TEMPLATE = {
  FamilyInvitation: "Family Invitation",
  NewOTCOffer: "New OTC Offer",
  BustOutPrisoner: "Bust Out Prisoner",
  BuyOutPrisoner: "Buy Out Prisoner",
};

